import * as bootstrap from 'bootstrap';
import Swiper from 'swiper/bundle';
import AOS from 'aos';
import Masonry from "masonry-layout";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

// --------------------------------
// Media query variables
const mediaQueryMD = window.matchMedia('(min-width: 768px)');

// Sticky navigation
const siteHeader = document.getElementById('site-header');
var siteHeaderHeight = ''.concat(siteHeader.offsetHeight, 'px');

window.addEventListener('resize', function() {
  siteHeaderHeight = ''.concat(siteHeader.offsetHeight, 'px');

});

document.addEventListener('scroll', function () {
  stickyHeader();
});

function stickyHeader() {

  if ( siteHeader ) {

    if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
      document.body.style.paddingTop = siteHeaderHeight;
      siteHeader.classList.add('fixed-top');
    } else {
      siteHeader.classList.remove('fixed-top');
      document.body.style.paddingTop = '0';
    }

  }
}

// Hide eu infoblokk
var infoblokk_button = document.getElementById("eu-infoblokk-button");
var infoblokk =  document.getElementById("eu-infoblokk-container");

if ( infoblokk ) {

  if (sessionStorage.getItem('szechenyi-infoblokk') === 'hide' ) {
    infoblokk_button.style.transition = "none";
    infoblokk_button.style.transform = "rotate(180deg)";
    infoblokk_button.style.bottom = "1rem";
    infoblokk.style.transition = "none";
    infoblokk.style.transform = "translateY(" + infoblokk.offsetHeight + "px)";
    infoblokk_button.classList.remove("hide-infoblokk");
    infoblokk_button.classList.add("show-infoblokk");
  }

  infoblokk_button.onclick = function() {
    if (infoblokk_button.classList.contains("hide-infoblokk")) {
      infoblokk_button.style.transform = "rotate(180deg)";
      infoblokk_button.style.bottom = "1rem";
      infoblokk.style.transform = "translateY(" + infoblokk.offsetHeight + "px)";
      infoblokk_button.classList.remove("hide-infoblokk");
      infoblokk_button.classList.add("show-infoblokk");
      sessionStorage.setItem('szechenyi-infoblokk', 'hide');
    } else if (infoblokk_button.classList.contains("show-infoblokk")) {
      infoblokk_button.style.transition = ".5s";
      infoblokk_button.style.transform = "rotate(0deg)";
      infoblokk_button.style.bottom = "225px";
      infoblokk.style.transition = ".5s";
      infoblokk.style.transform = "translateY(0px)";
      infoblokk_button.classList.remove("show-infoblokk");
      infoblokk_button.classList.add("hide-infoblokk");
      sessionStorage.setItem('szechenyi-infoblokk', 'show');
    }
  }
}

document.addEventListener('DOMContentLoaded', function(event) {

  AOS.init({
    once: true,
    disable: 'mobile',
  });

  const kezdooldalFoSlider = new Swiper('#kezdooldal-fo-slider', {
    effect: "fade",
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    on: {
      slideChangeTransitionStart: function () {
        document.querySelectorAll('.slide-item').forEach(function (item, index) {
          item.style.display = 'none';
          item.classList.remove('aos-init', 'aos-animate');
        });
      },
      slideChangeTransitionEnd: function () {
        document.querySelectorAll('.slide-item').forEach(function (item, index) {
          item.style.display = 'block';
        });
        AOS.init();
      },
    },
    loop: true,
  });

  const kezdooldalKategoriaSlider1 = new Swiper('#kezdooldal-kategoria-slider-1', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".kks1-swiper-button-next",
      prevEl: ".kks1-swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
      },
    },
  });

  const kezdooldalKategoriaSlider2 = new Swiper('#kezdooldal-kategoria-slider-2', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".kks2-swiper-button-next",
      prevEl: ".kks2-swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
      },
    },
  });

})

